import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
import { getBrandToken } from "./getBrand";
import { getRetailerToken } from "./getRetailer";
export var getUser = function getUser() {
  return getGlobalProperty("user");
};
export var getIsLoggedInUser = function getIsLoggedInUser() {
  var retailerToken = getRetailerToken();
  var brandToken = getBrandToken();
  return !!retailerToken || !!brandToken;
};
export var getUserToken = function getUserToken() {
  var _getUser;
  return (_getUser = getUser()) === null || _getUser === void 0 ? void 0 : _getUser.token;
};
export var getUserEmail = function getUserEmail() {
  var _ref, _user$email_address;
  var user = getUser();
  return (_ref = (_user$email_address = user === null || user === void 0 ? void 0 : user.email_address) !== null && _user$email_address !== void 0 ? _user$email_address : user === null || user === void 0 ? void 0 : user.additional_email_address) !== null && _ref !== void 0 ? _ref : "";
};
export var getUserFullName = function getUserFullName() {
  var _user$first_name$trim, _user$first_name, _user$last_name$trim, _user$last_name;
  var user = getUser();
  return user ? "".concat((_user$first_name$trim = user === null || user === void 0 ? void 0 : (_user$first_name = user.first_name) === null || _user$first_name === void 0 ? void 0 : _user$first_name.trim()) !== null && _user$first_name$trim !== void 0 ? _user$first_name$trim : "", " ").concat((_user$last_name$trim = user === null || user === void 0 ? void 0 : (_user$last_name = user.last_name) === null || _user$last_name === void 0 ? void 0 : _user$last_name.trim()) !== null && _user$last_name$trim !== void 0 ? _user$last_name$trim : "").trim() : "";
};
export var getUserPhoneNumber = function getUserPhoneNumber() {
  var _user$phone_number;
  var user = getUser();
  return (_user$phone_number = user === null || user === void 0 ? void 0 : user.phone_number) !== null && _user$phone_number !== void 0 ? _user$phone_number : "";
};
export var getUserType = function getUserType() {
  var user = getUser();
  return user === null || user === void 0 ? void 0 : user.type;
};
export var getUserIsImpersonating = function getUserIsImpersonating() {
  var _getUser2;
  return !!((_getUser2 = getUser()) !== null && _getUser2 !== void 0 && _getUser2.impersonating);
};
export var getUserFirstName = function getUserFirstName() {
  var _getUser$first_name, _getUser3;
  return (_getUser$first_name = (_getUser3 = getUser()) === null || _getUser3 === void 0 ? void 0 : _getUser3.first_name) !== null && _getUser$first_name !== void 0 ? _getUser$first_name : "";
};